import {ref, Ref} from "vue"

const showErrors: Ref<boolean> = ref(false)

export default showErrors